import mapboxgl from "mapbox-gl";

const SELECTION_COLOR = "#3bb2d0";

/**
 * Paint & layout for the map selection polygon.
 */
export const selectionPolygonFillPaint: mapboxgl.FillPaint = {
  "fill-color": SELECTION_COLOR,
  "fill-outline-color": SELECTION_COLOR,
  "fill-opacity": 0.1,
};

export const selectionPolygonLineLayout: mapboxgl.LineLayout = {
  "line-cap": "round",
  "line-join": "round",
};

/**
 * Paint for the mask dimming the map outside the selection.
 */
export const selectionMaskFillPaint: mapboxgl.FillPaint = {
  "fill-color": "#000000",
  "fill-opacity": 0.35,
};

export const selectionPolygonLinePaint: mapboxgl.LinePaint = {
  "line-color": SELECTION_COLOR,
  "line-dasharray": [0.2, 2],
  "line-width": 2,
};
